import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Row,
  Col,
  message,
  Space,
  Form,
  Avatar,
  Typography,
  Radio,
} from "antd";
import bg from "assets/image/confirm.jpg";
import ntxLogo from "assets/image/ntx-no-background.png";
import thankConfirm from "assets/image/thank_confirm.jpg";
import { OrderConfirmServices } from "services/OrderConfirm";
const ConfirmOrder = (props) => {
  const [form] = Form.useForm();
  const optionSelected = Form.useWatch("action", form);
  const [isConfirmed, setConfirm] = useState(false);

  const handleSubmit = (v) => {
    const idParam = props?.match?.params?.id;
    if (idParam) {
      OrderConfirmServices.confirmRecievedSchedule({
        id: idParam,
        action: v?.action,
        note: v?.note,
      })
        .then(() => {
          message.success("Xác nhận thành công");
          getBill();
        })
        .catch(() => {
          message.error("Vui lòng thử lại sau");
        });
    }
  };

  const handleConfirmNow = () => {
    const idParam = props?.match?.params?.id;
    if (idParam) {
      OrderConfirmServices.confirmRecievedNow({ id: idParam });
      message.success("Xác nhận thành công");
    }
  };

  const getBill = () => {
    const idParam = props?.match?.params?.id;
    if (idParam) {
      OrderConfirmServices.showBillZns({ id: idParam })
        .then((res) => {
          const isClick = res?.data?.data?.is_clicked ?? "D";
          setConfirm(isClick);
        })
        .catch(() => {
          setConfirm(null);
        });
    }
  };

  useEffect(() => {
    getBill();
  }, []);

  return (
    <div
      style={{
        maxWidth: 500,
        margin: "0 auto",
        textAlign: "center",
        padding: "20px",
        border: "1px solid #f0f0f0",
        borderRadius: "10px",
        backgroundColor: "#fafafa",
      }}
    >
      <h4>
        <Avatar src={ntxLogo} style={{ width: "25%" }} /> Hẹn giao hàng
      </h4>

      <img
        src={isConfirmed === "D" ? bg : thankConfirm}
        alt="Cảm ơn"
        style={{ width: "50%", marginBottom: "20px", borderRadius: "10px" }}
      />

      {isConfirmed === "A" ? (
        <Row justify={"center"}>
          <Typography.Text>Cảm ơn bạn đã gửi xác nhận</Typography.Text>
        </Row>
      ) : (
        <Space direction="vertical">
          <Form layout="vertical" form={form} onFinish={handleSubmit}>
            <Form.Item
              label="Vui lòng chọn thời gian giao hàng"
              name={"action"}
              rules={[
                {
                  required: true,
                  message: "Vui lòng chọn thời gian giao hàng",
                },
              ]}
            >
              <Radio.Group>
                <Row gutter={[8, 8]} align="middle" justify="start">
                  <Col xs={24} sm={24} md={8} className="ant-col-flex">
                    <Radio style={{ float: "left" }} value={2}>
                      Hẹn giao ngày mai
                    </Radio>
                  </Col>
                  <Col xs={24} sm={24} md={8} className="ant-col-flex">
                    <Radio style={{ float: "left" }} value={3}>
                      Từ chối nhận
                    </Radio>
                  </Col>
                  <Col xs={24} sm={24} md={8} className="ant-col-flex">
                    <Radio style={{ float: "left" }} value={4}>
                      Yêu cầu khác
                    </Radio>
                  </Col>
                </Row>
              </Radio.Group>
            </Form.Item>
            {optionSelected === 4 ? (
              <Form.Item
                name={"note"}
                label="Yêu cầu"
                rules={[
                  { required: true, message: "Vui lòng nhập nội dung yêu cầu" },
                ]}
              >
                <Input.TextArea rows={2} />
              </Form.Item>
            ) : null}
            <Row justify="center" className="mt-3">
              <Col>
                <Space>
                  <Button type="primary" htmlType="submit">
                    Gửi xác nhận
                  </Button>
                </Space>
              </Col>
            </Row>
          </Form>
        </Space>
      )}
    </div>
  );
};

export default ConfirmOrder;
